import React from "react";
import PageHeading from "../../components/PageHeading";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import DCard from "../../components/DCard";
import ProductSubForm from "../../components/Forms/ProductSubForm";
import * as Yup from "yup";
import {
    formattedProviders,
    imageFormat,
    imageSize,
} from "../../utils/functions";
import { useQueries, useQueryClient } from "react-query";
import productServices from "../../services/products";
import DSpinner from "../../components/DSpinner";
import { toast } from "react-hot-toast";
import providerServices from "../../services/ApiProviders";

const validationSchema = Yup.object().shape({
    productImage: Yup.mixed()
        .test("image-format", "يرجى تحميل صورة", value => {
            return value
                ? imageFormat.includes(value.type.split("/")[1])
                : false;
        })
        .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", value => {
            return value ? imageSize >= value.size : false;
        })
        .required("الصورة مطلوبة"),
    productName: Yup.string()
        .required("هذا الحقل مطلوب")
        .min(3, "يجب اني يكون على الاقل 3 احرف"),
    productId: Yup.string().when("isAuto", {
        is: true,
        then: () => Yup.string().required("هذا الحقل مطلوب"),
    }),
    productPrice1: Yup.number()
        .typeError("يجب ان يكون رقم")
        .moreThan(0, "يجب ان يكون اكبر من الصفر")
        .required("هذا الحقل مطلوب"),
    productPrice2: Yup.number()
        .typeError("يجب ان يكون رقم")
        .moreThan(0, "يجب ان يكون اكبر من الصفر")
        .required("هذا الحقل مطلوب"),
    productPrice3: Yup.number()
        .typeError("يجب ان يكون رقم")
        .moreThan(0, "يجب ان يكون اكبر من الصفر")
        .required("هذا الحقل مطلوب"),

    provider: Yup.string().when("isAuto", {
        is: true,
        then: () => Yup.string().required("هذا الحقل مطلوب"),
    }),
});
const initialValues = {
    productName: "",
    productImage: "",
    productPrice1: "",
    productPrice2: "",
    productPrice3: "",
    productId: "",
    quantityMax: "",
    quantityMin: "",
    isAuto: false,
    countable: true,
    note: "",
    provider: "",
};
const AddSubProduct = ({ title }) => {
    const { id } = useParams();
    const results = useQueries([
        {
            queryKey: "getPrimaryProduct",
            queryFn: () => productServices.getProduct(id),
        },
        {
            queryKey: "getAllProviders",
            queryFn: () => providerServices.getAllProviders(),
        },
    ]);
    const [
        { data: primaryProduct, isLoading: primaryProductLoading },
        { data: providers, isLoading: providersIsLoading },
    ] = results;
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const onSubmit = (values, { setSubmitting }) => {
        const formData = new FormData();
        formData.append("name", values.productName);
        formData.append("countable", 1);
        formData.append("api_id", values.productId);
        formData.append("level_one", values.productPrice1);
        formData.append("level_two", values.productPrice2);
        formData.append("level_three", values.productPrice3);
        formData.append("note_ar", values.noteAr);
        formData.append("qty_max", values.qty_max);
        formData.append("qty_min", values.qty_min);
        formData.append("note_en", values.noteEn);
        formData.append("img", values.productImage);
        formData.append("api_provider_id", values.provider);
        productServices
            .addSubProduct(formData, id)
            .then(res => {
                toast.success("تم اضافة المنتج بنجاح");
                queryClient.refetchQueries("getSubProducts");
                setTimeout(() => {
                    navigate(`/products/${id}`);
                }, 1500);
            })
            .catch(err => {
                console.log(err);
                toast.error("فشل اضافة المنتج");
                setTimeout(() => {
                    setSubmitting(false);
                }, 1500);
            });
    };

    if (isNaN(Number(id)) || !id) {
        return <Navigate to="/404" />;
    }
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard
                className={
                    primaryProductLoading || providersIsLoading
                        ? "relative min-h-[400px]"
                        : ""
                }
            >
                {primaryProductLoading || providersIsLoading ? (
                    <DSpinner />
                ) : (
                    <ProductSubForm
                        validationSchema={validationSchema}
                        initialValues={{
                            ...initialValues,
                            productPrimaryName: primaryProduct.data.data.name,
                        }}
                        providersOptions={formattedProviders(providers.data)}
                        onSubmit={onSubmit}
                        btnText={"إضافة الباقة"}
                    />
                )}
            </DCard>
        </div>
    );
};

export default AddSubProduct;
